'use strict';

var AlertsPanelDirective = function AlertsPanelDirective($rootScope, $log) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/alerts-panel.html'),
    controller: require('../controllers/AlertsPanelController'),
    scope: {
      performanceChartSelectedMonths: '='
    },
    link: function link($scope, element) {
      $scope.$on('brush-filter:filterApplied', function () {
        $rootScope.$broadcast('brush-filter:filterApplied:updateToolbar');
      });
      element.on('rowselect', $scope.rowSelectionChanged);
      element.on('rowunselect', $scope.rowSelectionChanged);
      element.on('show.bs.modal', function () {
        $scope.resetGridPanel();
        $log.metric('dashboard.alerts', 1, 'drawer');
      });
      element.on('hide.bs.modal', function () {
        $scope.clearSelection();
      });
      $scope.hidePanel = function () {
        element.modal('hide');
      };
    }
  };
};
AlertsPanelDirective.$inject = ['$rootScope', '$log'];
module.exports = AlertsPanelDirective;